module.exports = __webpack_public_path__ + "static/img/release_done.cd59e007.png";